import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { HomeIcon, FileTextIcon, UsersIcon, CalendarIcon, CreditCardIcon, MailIcon, BarChartIcon, SettingsIcon, XIcon, PackageIcon, ClipboardListIcon, BuildingIcon, ScaleIcon, FileSignatureIcon, ClockIcon } from 'lucide-react';
interface SidebarProps {
  mobile?: boolean;
  onClose?: () => void;
}
export function Sidebar({
  mobile,
  onClose
}: SidebarProps) {
  const location = useLocation();
  const pathname = location.pathname;
  const navigation = [{
    name: 'Dashboard',
    icon: HomeIcon,
    path: '/',
    current: pathname === '/'
  }, {
    name: 'Clienti',
    icon: UsersIcon,
    path: '/clienti',
    current: pathname === '/clienti'
  }, {
    name: 'Piani di Rientro',
    icon: ClipboardListIcon,
    path: '/piani-rientro',
    current: pathname === '/piani-rientro'
  }, {
    name: 'Cessione Credito',
    icon: FileSignatureIcon,
    path: '/cessione-credito',
    current: pathname === '/cessione-credito'
  }, {
    name: 'Legal',
    icon: ScaleIcon,
    path: '/legal',
    current: pathname === '/legal'
  }, {
    name: 'Scadenze',
    icon: ClockIcon,
    path: '/scadenze',
    current: pathname === '/scadenze'
  }, {
    name: 'Corrispondenza',
    icon: MailIcon,
    path: '/corrispondenza',
    current: pathname === '/corrispondenza'
  }, {
    name: 'Report',
    icon: BarChartIcon,
    path: '/report',
    current: pathname === '/report'
  }, {
    name: 'Impostazioni',
    icon: SettingsIcon,
    path: '/impostazioni',
    current: pathname === '/impostazioni'
  }];
  return <div className="flex flex-col h-full bg-white border-r border-gray-100 w-64" data-id="element-892">
      {mobile && <div className="flex items-center justify-between px-4 py-3" data-id="element-893">
          <div className="flex items-center" data-id="element-894">
            <span className="text-[#7B68EE] text-xl font-semibold" data-id="element-895">
              CashFirst
            </span>
          </div>
          <button type="button" className="text-gray-500" onClick={onClose} data-id="element-896">
            <XIcon className="h-6 w-6" data-id="element-897" />
          </button>
        </div>}
      {!mobile && <div className="flex items-center h-16 flex-shrink-0 px-6" data-id="element-898">
          <span className="text-[#7B68EE] text-xl font-semibold" data-id="element-899">
            CashFirst
          </span>
        </div>}
      <div className="mt-5 flex-1 flex flex-col overflow-y-auto px-3" data-id="element-900">
        <nav className="flex-1 space-y-1" data-id="element-901">
          {navigation.map(item => <Link key={item.name} to={item.path} className={`
                group flex items-center px-3 py-2.5 text-sm font-medium rounded-lg transition-colors
                ${item.current ? 'bg-[#7B68EE]/10 text-[#7B68EE]' : 'text-gray-700 hover:bg-gray-50 hover:text-[#7B68EE]'}
              `} onClick={mobile ? onClose : undefined} data-id="element-902">
              <item.icon className={`
                  mr-3 flex-shrink-0 h-5 w-5
                  ${item.current ? 'text-[#7B68EE]' : 'text-gray-400 group-hover:text-[#7B68EE]'}
                `} aria-hidden="true" data-id="element-903" />
              {item.name}
            </Link>)}
        </nav>
        <div className="mt-auto pb-5 pt-5" data-id="element-904">
          <div className="px-3 py-3 rounded-lg bg-gradient-to-r from-[#7B68EE] to-[#FF6B81] text-white" data-id="element-905">
            <p className="text-sm font-medium" data-id="element-906">Hai bisogno di aiuto?</p>
            <p className="text-xs mt-1 opacity-90" data-id="element-907">
              Contatta il nostro supporto per assistenza
            </p>
            <button className="mt-2 w-full bg-white/20 hover:bg-white/30 text-white text-xs py-1.5 px-2 rounded-md transition-colors" data-id="element-908">
              Contatta Supporto
            </button>
          </div>
        </div>
      </div>
    </div>;
}